import SubscriptionPlansStore, {PlanStore} from "../../../stores/subscription-plans-store";
import {observer} from "mobx-react-lite";
import FontBody2 from "../../../../../components/fonts/font-body2/font-body2";
import {FONT_COLOR, FONT_VARIANT} from "../../../../../components/fonts/font-props";
import FontHeading3 from "../../../../../components/fonts/font-heading3/font-heading3";
import FontBody4 from "../../../../../components/fonts/font-body4/font-body4";
import './plan-pricing.scss';
import InstallmentsView from "../../installments-view/installments-view";

interface IPlanPricing {
    plan: PlanStore
}

const PlanPricing: React.FC<IPlanPricing> = observer(({plan}: IPlanPricing) => {
    return <div className="plan-pricing-wrapper">
        <div className="plan-pricing-values">
            {!plan.isAnnualPlan()
                ? <>
                    <FontHeading3 variant={FONT_VARIANT.BOLD}>
                        {SubscriptionPlansStore.userPlan?.userAddons && SubscriptionPlansStore.userPlan?.userAddons?.length !== 0
                            ? plan.formattedPriceWithAddons
                            : plan.formattedPrice
                        }
                    </FontHeading3>
                    <FontBody2 color={FONT_COLOR.NEUTRAL3}> / month</FontBody2>
                </>
                : !plan.hasInstallments()
                    ? <>
                        <FontHeading3 variant={FONT_VARIANT.BOLD}>
                            {SubscriptionPlansStore.userPlan?.userAddons && SubscriptionPlansStore.userPlan?.userAddons?.length !== 0
                                ? plan.formattedTotalAnnualPlanPrice
                                : plan.formattedBasePrice
                            }
                        </FontHeading3>
                        <FontBody2 color={FONT_COLOR.NEUTRAL3}> / year</FontBody2>
                      </>
                    : <>
                        <FontHeading3 variant={FONT_VARIANT.BOLD}>
                            { plan.formattedBasePrice }
                        </FontHeading3>
                        <FontBody2 color={FONT_COLOR.NEUTRAL3}> / {plan.parentPlan?.period} months</FontBody2>
                    </>
            }
        </div>

        <InstallmentsView plan={plan}/>

        {(SubscriptionPlansStore.userPlan?.userAddons && SubscriptionPlansStore.userPlan?.userAddons.length !== 0) &&
            <div className="plan-pricing-addons-wrapper">
                <FontBody4>* Prices shown include addons </FontBody4>
            </div>
        }
    </div>;
});

export default PlanPricing;